import {isNumberKey} from "common/helpers";
import {map} from 'lodash';
import React from "react";
import {ScaleCircles} from "components/AgreeabilityScale";
import { useSetTranslation } from "common/useSetTranslation";

// Past five points the labels no longer fit side by side, so the scale runs
// down the page instead of across it.
const STACK_FROM = 6;

const Scale = ({onAnswered, value, question: {key, scaleQuestionnaire: {sorting, options}}}) => {
  const {st} = useSetTranslation();

  const minimumValue = sorting === 'Ascending' ? options[0].option : options[options.length - 1].option;
  const maximumValue = sorting === 'Ascending' ? options[options.length - 1].option : options[0].option;

  const handleChange = (n) => {
    onAnswered(n);
  };

  const handleKeyPress = (event) => {
    if (isNumberKey(event)) {
      const keyNumber = parseInt(event.key);
      if (keyNumber <= maximumValue && keyNumber >= minimumValue) {
        onAnswered(keyNumber);
      }
    }
  };

  const scaleOptions = map(options, scaleOption => ({
    value: scaleOption.option,
    label: st(scaleOption.label, scaleOption.localeLabel),
  }));

  return (
    <ScaleCircles
      options={scaleOptions}
      value={value}
      questionKey={key}
      onSelect={handleChange}
      onKeyDown={handleKeyPress}
      stacked={options.length >= STACK_FROM}
    />
  );
};


export default (Scale);
